import dibalikSimulasi3Azkia25 from "../../Assets/Dibalik/Copy of Copy of Simulasi 3_Azkia25 Large.jpeg";
import dibalikSimulasi3Azkia29 from "../../Assets/Dibalik/Copy of Copy of Simulasi 3_Azkia29 Large.jpeg";
import dibalikSimulasi3Thirza072 from "../../Assets/Dibalik/Copy of Copy of Simulasi 3_Thirza Abigail_072 Large.jpeg";
import dibalikGladiBersihBernice31 from "../../Assets/Dibalik/Copy of Gladi Bersih-Bernice-31 Large.jpeg";
import dibalikGladiBersihBernice40 from "../../Assets/Dibalik/Copy of Gladi Bersih-Bernice-40 Large.jpeg";
import dibalikGladiKotorThirza34 from "../../Assets/Dibalik/Copy of Gladi Kotor-Thirza-34 Large.jpeg";
import dibalikGladiKotorThirza47 from "../../Assets/Dibalik/Copy of Gladi Kotor-Thirza-47 Large.jpeg";
import dibalikGladiKotorThirza60 from "../../Assets/Dibalik/Copy of Gladi Kotor-Thirza-60 Large.jpeg";
import dibalikPembentukan2Cinta26 from "../../Assets/Dibalik/Copy of Hari Pembentukan 2_Cinta_26 Large.jpeg";
import dibalikLatihanInagurasiCinta9 from "../../Assets/Dibalik/Copy of Latihan Inagurasi_Cinta_9 Large.jpeg";
import dibalikLatihanUpacaraCinta12 from "../../Assets/Dibalik/Copy of Latihan Upacara_Cinta_12 Large.jpeg";
import dibalikPembentukan2Johan127 from "../../Assets/Dibalik/Copy of Pembentukan Hari 2_Johan_127 Large.jpeg";
import dibalikPembentukan2Johan148 from "../../Assets/Dibalik/Copy of Pembentukan Hari 2_Johan_148 Large.jpeg";
import dibalikPembentukan2Johan161 from "../../Assets/Dibalik/Copy of Pembentukan Hari 2_Johan_161 Large.jpeg";
import dibalikPembentukan2Johan169 from "../../Assets/Dibalik/Copy of Pembentukan Hari 2_Johan_169 Large.jpeg";
import dibalikPembentukan2Johan180 from "../../Assets/Dibalik/Copy of Pembentukan Hari 2_Johan_180 Large.jpeg";
import dibalikGladiBersihAndrew95 from "../../Assets/Dibalik/Copy of Pers_Gladi Bersih_Andrew Su-95 Large.jpeg";
import dibalikRapatJohan35 from "../../Assets/Dibalik/Copy of Rapat Insidental_Johan Felix_35 Large.jpeg";
import dibalikSimulasi1Johan11 from "../../Assets/Dibalik/Copy of Simulasi 1_Johan Felix_11 Large.jpeg";
import dibalikSimulasi2Cinta22 from "../../Assets/Dibalik/Copy of Simulasi 2_Cinta_22 Large.jpeg";
import dibalikSimulasi2Cinta54 from "../../Assets/Dibalik/Copy of Simulasi 2_Cinta_54 Large.jpeg";
import dibalikSimulasi2Cinta56 from "../../Assets/Dibalik/Copy of Simulasi 2_Cinta_56 Large.jpeg";
import dibalikSimulasi2Cinta58 from "../../Assets/Dibalik/Copy of Simulasi 2_Cinta_58 Large.jpeg";
import dibalikSimulasi3Kenzie100 from "../../Assets/Dibalik/Copy of Simulasi 3_Kenzie Andhika Theodorus Suhanto_100 Large.jpeg";
import dibalikSimulasi3Kenzie102 from "../../Assets/Dibalik/Copy of Simulasi 3_Kenzie Andhika Theodorus Suhanto_102 Large.jpeg";
import dibalikSimulasi3Kenzie97 from "../../Assets/Dibalik/Copy of Simulasi 3_Kenzie Andhika Theodorus Suhanto_97 Large.jpeg";
import dibalikSimulasi3Ravalen39 from "../../Assets/Dibalik/Copy of Simulasi 3_Ravalen Virginia_39 Large.jpeg";
import dibalikSimulasi3Ravalen49 from "../../Assets/Dibalik/Copy of Simulasi 3_Ravalen Virginia_49 Large.jpeg";
import dibalikSioJohan10 from "../../Assets/Dibalik/Copy of SIO_Johan Felix_10 Large.jpeg";
import dibalikSioJohan7 from "../../Assets/Dibalik/Copy of SIO_Johan Felix_7 Large.jpeg";
import dibalikSioJohan8 from "../../Assets/Dibalik/Copy of SIO_Johan Felix_8 Large.jpeg";
import dibalikTutorJambiRavalen07 from "../../Assets/Dibalik/Copy of Tutor Jambi_Ravalen Virginia_07 Large.jpeg";
import dibalikTutorKampana1Azkia9 from "../../Assets/Dibalik/Copy of Tutor Kampana 1_Azkia Noor Aina Thalib_9 Large.jpeg";
import dibalikTutorKampana3Cinta11 from "../../Assets/Dibalik/Copy of TUTOR KAMPANA 3_Mutiara Cinta Auliana_00011 Large.jpeg";
import dibalikTutorKampanaArsaRavalen10 from "../../Assets/Dibalik/Copy of Tutor Kampana x Arsa 1_Ravalen Virginia_10 Large.jpeg";
import dibalikTutorPadang2Devin25 from "../../Assets/Dibalik/Copy of Tutor Padang 2_Devin_25 Large.jpeg";

const fotoDibalikPanit = [
  { id: 1, img: dibalikSimulasi3Azkia25 },
  { id: 2, img: dibalikSimulasi3Azkia29 },
  { id: 3, img: dibalikSimulasi3Thirza072 },
  { id: 4, img: dibalikGladiBersihBernice31 },
  { id: 5, img: dibalikGladiBersihBernice40 },
  { id: 6, img: dibalikGladiKotorThirza34 },
  { id: 7, img: dibalikGladiKotorThirza47 },
  { id: 8, img: dibalikGladiKotorThirza60 },
  { id: 9, img: dibalikPembentukan2Cinta26 },
  { id: 10, img: dibalikLatihanInagurasiCinta9 },
  { id: 11, img: dibalikLatihanUpacaraCinta12 },
  { id: 12, img: dibalikPembentukan2Johan127 },
  { id: 13, img: dibalikPembentukan2Johan148 },
  { id: 14, img: dibalikPembentukan2Johan161 },
  { id: 15, img: dibalikPembentukan2Johan169 },
  { id: 16, img: dibalikPembentukan2Johan180 },
  { id: 17, img: dibalikGladiBersihAndrew95 },
  { id: 18, img: dibalikRapatJohan35 },
  { id: 19, img: dibalikSimulasi1Johan11 },
  { id: 20, img: dibalikSimulasi2Cinta22 },
  { id: 21, img: dibalikSimulasi2Cinta54 },
  { id: 22, img: dibalikSimulasi2Cinta56 },
  { id: 23, img: dibalikSimulasi2Cinta58 },
  { id: 24, img: dibalikSimulasi3Kenzie100 },
  { id: 25, img: dibalikSimulasi3Kenzie102 },
  { id: 26, img: dibalikSimulasi3Kenzie97 },
  { id: 27, img: dibalikSimulasi3Ravalen39 },
  { id: 28, img: dibalikSimulasi3Ravalen49 },
  { id: 29, img: dibalikSioJohan10 },
  { id: 30, img: dibalikSioJohan7 },
  { id: 31, img: dibalikSioJohan8 },
  { id: 32, img: dibalikTutorJambiRavalen07 },
  { id: 33, img: dibalikTutorKampana1Azkia9 },
  { id: 34, img: dibalikTutorKampana3Cinta11 },
  { id: 35, img: dibalikTutorKampanaArsaRavalen10 },
  { id: 36, img: dibalikTutorPadang2Devin25 }
];

export default fotoDibalikPanit;